import { RequestStatus } from '../utils';
import {
    getMainMenuConfigFailure,
    getMainMenuConfigSuccess,
    getTemplateviewFailure,
    getTemplateviewRequest,
    getTemplateviewSuccess,
} from './actions';
import {
    GET_MAIN_MENU_CONFIG_FAILURE,
    GET_MAIN_MENU_CONFIG_REQUEST,
    GET_MAIN_MENU_CONFIG_SUCCESS,
    GET_TEMPLATEVIEW_FAILURE,
    GET_TEMPLATEVIEW_REQUEST,
    GET_TEMPLATEVIEW_SUCCESS,
} from './constants';
import { RailsBuilderState } from './reducer.types';

const initialState: RailsBuilderState = {
    getMainMenuConfigRequest: {
        status: RequestStatus.IDLE,
        error: null,
        standardMenu: [],
        kidsMenu: [],
    },
    templateviewsById: {},
};

const handlers = {
    [GET_MAIN_MENU_CONFIG_REQUEST](
        state: RailsBuilderState,
    ): RailsBuilderState {
        return {
            ...state,
            getMainMenuConfigRequest: {
                ...state.getMainMenuConfigRequest,
                status: RequestStatus.PENDING,
                error: null,
            },
        };
    },
    [GET_MAIN_MENU_CONFIG_SUCCESS](
        state: RailsBuilderState,
        {
            payload: { standardMenu, kidsMenu },
        }: ReturnType<typeof getMainMenuConfigSuccess>,
    ): RailsBuilderState {
        return {
            ...state,
            getMainMenuConfigRequest: {
                ...state.getMainMenuConfigRequest,
                status: RequestStatus.SUCCESS,
                error: null,
                standardMenu,
                kidsMenu,
            },
        };
    },
    [GET_MAIN_MENU_CONFIG_FAILURE](
        state: RailsBuilderState,
        { payload: { error } }: ReturnType<typeof getMainMenuConfigFailure>,
    ): RailsBuilderState {
        return {
            ...state,
            getMainMenuConfigRequest: {
                ...state.getMainMenuConfigRequest,
                status: RequestStatus.FAILURE,
                error,
            },
        };
    },
    [GET_TEMPLATEVIEW_REQUEST](
        state: RailsBuilderState,
        { payload: { id } }: ReturnType<typeof getTemplateviewRequest>,
    ): RailsBuilderState {
        return {
            ...state,
            templateviewsById: {
                ...state.templateviewsById,
                [id]: {
                    ...state.templateviewsById[id],
                    status: RequestStatus.PENDING,
                },
            },
        };
    },
    [GET_TEMPLATEVIEW_SUCCESS](
        state: RailsBuilderState,
        {
            payload: { id, templateview },
        }: ReturnType<typeof getTemplateviewSuccess>,
    ): RailsBuilderState {
        return {
            ...state,
            templateviewsById: {
                ...state.templateviewsById,
                [id]: {
                    data: templateview,
                    status: RequestStatus.SUCCESS,
                },
            },
        };
    },
    [GET_TEMPLATEVIEW_FAILURE](
        state: RailsBuilderState,
        { payload: { id } }: ReturnType<typeof getTemplateviewFailure>,
    ): RailsBuilderState {
        return {
            ...state,
            templateviewsById: {
                ...state.templateviewsById,
                [id]: {
                    ...state.templateviewsById[id],
                    status: RequestStatus.FAILURE,
                },
            },
        };
    },
};

export default { initialState, handlers };
